import styled from 'styled-components';
import {COLORS} from '../../values/colors';
import {motion} from 'framer-motion';

export const LargerHeading = styled.h1`	
  font-size: 4rem;
  margin-bottom: 2rem;
  @media (max-width: 1050px) {
    font-size: 2.75rem;
  }
  @media (max-width: 620px) {
    font-size: 2rem;
  }
`;
export const LargeHeading = styled.h2`
  font-size: 3rem;
  margin-bottom: 1rem;
  @media (max-width: 1050px) {
    font-size: 2.5rem;
  }
  @media (max-width: 620px) {
    font-size: 1.75rem;
  }
`;

export const Paragraph = styled(motion.p)<{ color?: string }>`
  font-size: 1.1rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  color: ${({ color }) => color || COLORS.white};
  @media (max-width: 620px) {
    font-size: 1rem;
  }
`;
